module.exports = __webpack_public_path__ + "static/media/mail.e2ab4a55.svg";